import { defineStore } from 'pinia';
import spacesApiService from '@/services/spaces.api.service';
import { CwxBackend } from '@/types/cwxBackend';

export const useSpaceStore = defineStore('space', {
  state: () => ({
    spaceDetails: {} as CwxBackend.ISpaceDetailsDto,
    spaceSettings: {} as CwxBackend.ISpaceSettingsDto,
    isSpaceDetailsLoaded: false,
  }),
  actions: {
    async fetchSpaceDetails(spaceId: number) {
      this.isSpaceDetailsLoaded = false;
      this.spaceDetails = await spacesApiService.getSpaceDetails(spaceId);
      this.isSpaceDetailsLoaded = true;
    },
    async fetchSpaceSettings(spaceId: number) {
      this.spaceSettings = await spacesApiService.getSpaceSettings(spaceId);
    },
    clearSpaceContext() {
      this.spaceDetails = {} as CwxBackend.ISpaceDetailsDto;
      this.isSpaceDetailsLoaded = true;
    },
  },
});
